export const formatPassword = password => {
    if (!password) return ''
    return password.replace(/\s/g, '')
}